'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ItemDetailRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemDetailRemote = exports.ItemDetailRemote = {
    fetchItemDetailsByIds: function fetchItemDetailsByIds(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment,
            itemIds = _ref.itemIds;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({ authToken: authToken, deployment: deployment, path: '<ITEM-API>spa/small/item-detail' });
            request.send({ itemIds: itemIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/itemDetail.js
// module id = rjim
// module chunks = 60